import { Box, Divider, ListItem, ListItemText } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import React, { useEffect, useState } from "react";
import { ICON } from "../../assets";
import { price, ucfirst } from "../../utils";
import { useAuth } from "../Auth/useAuth";
import CurrentCart from "../Carts/CurrentCart";
import { useCart } from "../Carts/useCart";
import useTranslations from "../Translations/useTranslations";
import Text from "../ui/Text";
import theme from "../ui/theme";
import UiButton, { UI_BUTTON_TYPE } from "../ui/UiButton";
import UiIcon from "../ui/UiIcon";
import UiSearch from "../ui/UiSearch";
import UiTag, { UI_TAG_TYPE } from "../ui/UiTag";
import "./SidebarControls.css";

function SidebarControls({
  items,
  codfag,
  selectItem = () => {},
  set_search_criteria = () => {},
  search_value,
  selected_criteres,
  selectCritere,
  resetCritere,
}) {
  const formatTitle = (title) => {
    if (!title) return "";
    return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
  };

  const trl = useTranslations();
  const getTitle = formatTitle(
    trl.data.message("FAG", "CODFAG", codfag, "LIBFAG"),
  );
  const [auth] = useAuth();
  const [title, updateTitle] = useState(getTitle);

  const [{ current_cart }, { getCartData }] = useCart(
    auth.user.client_profile?.id,
  );
  const [cartModalOpened, setCartModalOpened] = useState(false);
  const [catalogueModalOpen, setCatalogueModalOpen] = useState(false);
  useEffect(() => {
    updateTitle(getTitle);
  }, [codfag]);

  useEffect(() => {
    search_value
      ? updateTitle('Recherche pour "' + search_value + '"')
      : updateTitle(getTitle);
  }, [search_value, getTitle]);

  const onSearchCriteraChange = (text) => {
    set_search_criteria(text);
  };
  function renderFilters() {
    return (
      <React.Fragment>
        <UiButton
          size="sm"
          buttonUiType={[UI_BUTTON_TYPE.ONLY_BORDER]}
          content={
            <React.Fragment>
              <div className="filter-button">
                <UiIcon
                  icon={ICON.filterCircleIcon}
                  alt="filter icon"
                  size="md"
                />
                <span className=" ">
                  {trl.message("MainPage.filtersAction")}
                </span>
              </div>
            </React.Fragment>
          }
          onClick={() => {
            const btn = document.getElementById("open-filters");
            if (btn) {
              btn.click();
            }
          }}
        />
        {selected_criteres.critere_1 && (
          <UiTag
            uiTagType={UI_TAG_TYPE.lightCream}
            content={
              <React.Fragment>
                {trl.data.message(
                  "CR1",
                  "CODCR1",
                  selected_criteres.critere_1,
                  "LIBCR1",
                )}
              </React.Fragment>
            }
            icon={ICON.boldCrossIcon}
            iconSize={8}
            fontSize={14}
            onClick={() =>
              selectCritere({ critere_1: selected_criteres.critere_1 })
            }
          />
        )}
        {selected_criteres.critere_2 && (
          <UiTag
            uiTagType={UI_TAG_TYPE.lightCream}
            content={
              <React.Fragment>
                {trl.data.message(
                  "CR2",
                  "CODCR2",
                  selected_criteres.critere_2,
                  "LIBCR2",
                )}
              </React.Fragment>
            }
            icon={ICON.boldCrossIcon}
            iconSize={8}
            fontSize={14}
            onClick={() =>
              selectCritere({ critere_2: selected_criteres.critere_2 })
            }
          />
        )}
        {selected_criteres.critere_3 && (
          <UiTag
            uiTagType={UI_TAG_TYPE.lightCream}
            content={
              <React.Fragment>
                {trl.data.message(
                  "CR3",
                  "CODCR3",
                  selected_criteres.critere_3,
                  "LIBCR3",
                )}
              </React.Fragment>
            }
            icon={ICON.boldCrossIcon}
            iconSize={8}
            fontSize={14}
            onClick={() =>
              selectCritere({ critere_3: selected_criteres.critere_3 })
            }
          />
        )}
      </React.Fragment>
    );
  }

  function renderCartActionButton() {
    const { mt_total, mt_total_remise_pack, cumul_plv_in_cart } = getCartData();
    const totalPrice = mt_total - mt_total_remise_pack - cumul_plv_in_cart;
    const buttonContent = () => {
      const currentPrice = price(totalPrice);
      return (
        <React.Fragment>
          <div className="cart-action-button">
            <span> {currentPrice + " €"} </span>
            <UiIcon icon={ICON.cartPlusFillIcon} alt="cart icon" size="md" />
          </div>
        </React.Fragment>
      );
    };

    return (
      <React.Fragment>
        <UiButton
          size="sm"
          content={buttonContent()}
          onClick={() => setCartModalOpened(true)}
          buttonUiType={[
            totalPrice <= 0 ? UI_BUTTON_TYPE.BG_WHITE : UI_BUTTON_TYPE.NORMAL,
          ]}
          disabled={totalPrice <= 0}
        />
        <Drawer
          open={cartModalOpened}
          anchor="right"
          onClose={() => setCartModalOpened(false)}
        >
          <CurrentCart closeCart={() => setCartModalOpened(false)} />
        </Drawer>
      </React.Fragment>
    );
  }

  function renderCatalogDrawerControls() {
    return (
      <React.Fragment>
        <div className="controls top-controls">
          <div className="control-group">
            <UiButton
              size="sm"
              content={trl.message("MainPage.FagList")}
              onClick={() => setCatalogueModalOpen(true)}
            />
          </div>
          <div className="control-group">
            <UiSearch
              placeholder={trl.message("MainPage.searchInputPlaceholder")}
              onSearch={(t) => onSearchCriteraChange(t)}
              value={search_value || ""}
              variant="mobile"
            />
          </div>
        </div>
        <Drawer
          anchor="left"
          open={catalogueModalOpen}
          onClose={() => setCatalogueModalOpen(false)}
        >
          <Box p={3}>
            <Text
              as="div"
              variant="title"
              style={{
                width: "100%",
                textAlign: "center",
                borderBottom: "3px solid " + theme.primary,
                paddingBottom: theme.spacing(1),
                marginBottom: theme.spacing(1),
              }}
            >
              {trl.message("NavigationMenu.title")}
            </Text>
          </Box>
          {items &&
            items.map((fag) => (
              <ListItem
                style={{ minWidth: "250px" }}
                key={fag.CODFAG}
                button
                onClick={() => {
                  selectItem(fag);
                  setCatalogueModalOpen(false);
                }}
                selected={codfag === fag.CODFAG}
              >
                <ListItemText
                  primary={ucfirst(
                    trl.data.message("FAG", "CODFAG", fag.CODFAG, "LIBFAG"),
                  )}
                />
              </ListItem>
            ))}
          <Divider />
        </Drawer>
      </React.Fragment>
    );
  }

  function renderSidebarControls() {
    return (
      <React.Fragment>
        <div className="controls">
          <div className="control-group">
            <div className="control-title">{title}</div>
            {renderFilters()}
          </div>
          <div className="control-group">{renderCartActionButton()}</div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div style={{ margin: "0 6%" }}>
        {renderCatalogDrawerControls()}
        {renderSidebarControls()}
      </div>
    </React.Fragment>
  );
}

export default SidebarControls;
